import RedirectWithStatus from 'components/Common/RedirectWithStatus'
import LayoutContainer from 'components/Common/LayoutContainer'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import Pane from 'components/Common/Pane'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import GeoContext from 'contexts/geoContext'
import { LOYALTY_LANDING_PAGE } from 'loyalty/constants/loyaltyRoutes'
import { useLoyaltyOffersHubRemoteConfig } from 'loyalty/hooks/useLoyaltyOffersHubRemoteConfig'
import LineAngleRightIcon from 'LuxKit/Icons/line/LineAngleRightIcon'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import LoyaltyOffersHubHeroCarousel from './LoyaltyOffersHubHeroCarousel'
import LoyaltyOffersHubLimitedTimeOffersSection from './LoyaltyOffersHubLimitedTimeOffersSection'
import LoyaltyOffersHubPartnerOffersSection from './LoyaltyOffersHubPartnerOffersSection'

const HeroSection = styled.div`
  background-color: ${props => props.theme.palette.neutral.control.black100};
`

function LoyaltyOffersHubPage() {
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)
  const { hasActiveContent, hasResolvedRemoteConfig, heroCarouselItems, industryFilters, limitedTimeOffers, partnerOffers } = useLoyaltyOffersHubRemoteConfig()
  const loyaltyLandingPagePath = `/${currentRegionCode.toLowerCase()}/${LOYALTY_LANDING_PAGE}`
  const yourMembershipText = intl.formatMessage({
    id: 'yMv1Ktx7jFDszD3Q8KUc',
    defaultMessage: 'Your Membership',
    description: 'Breadcrumb link text back to the Societe membership page',
  })
  const offersBreadcrumbText = intl.formatMessage({
    id: 'uQX6ng7g6Uhqod3Yhxrs',
    defaultMessage: 'Offers',
    description: 'Current breadcrumb label shown on the Societe offers hub page',
  })
  const societeOffersTitle = intl.formatMessage({
    id: '7E0lj3HIEuWLR7A65wue',
    defaultMessage: 'Société Offers',
    description: 'Main page title shown at the top of the Societe offers hub page',
  })

  if (!hasResolvedRemoteConfig) {
    return <LoadingIndicator />
  }

  if (!hasActiveContent) {
    return <RedirectWithStatus code={302} to={loyaltyLandingPagePath} />
  }

  return <>
    <HeroSection>
      <LayoutContainer variant="large">
        <Pane background="none" padding="40 20">
          <Group direction="vertical" gap={20}>
            <CSSBreakpoint min="tablet">
              <Group direction="horizontal" gap={8} verticalAlign="center">
                <TextLink to={`/${LOYALTY_LANDING_PAGE}`} size="small" weight="regular" colour="dark-contrast">
                  {yourMembershipText}
                </TextLink>
                <LineAngleRightIcon size="XXS" colour="dark-contrast" />
                <BodyText variant="small" colour="dark-contrast">
                  {offersBreadcrumbText}
                </BodyText>
              </Group>
            </CSSBreakpoint>
            <Heading variant="heading1" as="h1" colour="dark-contrast">
              {societeOffersTitle}
            </Heading>
            <LoyaltyOffersHubHeroCarousel items={heroCarouselItems} />
          </Group>
        </Pane>
      </LayoutContainer>
    </HeroSection>
    <LayoutContainer variant="large">
      <Pane background="none" padding="24 20 40">
        <Group direction="vertical" gap={0}>
          <LoyaltyOffersHubPartnerOffersSection offers={partnerOffers} industryFilters={industryFilters} />
          <LoyaltyOffersHubLimitedTimeOffersSection offers={limitedTimeOffers} />
        </Group>
      </Pane>
    </LayoutContainer>
  </>
}

export default LoyaltyOffersHubPage
